<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="桥隧名称">
            <el-input
              v-model="queryParams.bridgesTunnelsName"
              placeholder="请输入桥隧名称进行查询"
              class="form-item-width"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="warning" @click="onReset">重置</el-button>
            <el-button type="primary" @click="handlebridgesTunnelsAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table
        :data="tableData"
        stripe
        border
        row-key="deptId"
        default-expand-all
        :tree-props="{children: 'children'}"
        :header-cell-style="{ background: '#aef1f6', color: '#606266' }"
      >
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column
          align="center"
          v-for="tab in tableTitle"
          :key="tab.code"
          :label="tab.name"
          show-overflow-tooltip
          :width="tab.width"
        >
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span
              v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green'  } : { color: 'red'  }"
            >{{ scope.row.status === '0' ? '正常' : '停用' }}</span>
     
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button
              style="color:red"
              type="text"
              @click="deleteData(scope.row)"
              class="update-btn"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination
          :total="pageParams.total"
          :page="pageParams.pageNum"
          :limit="pageParams.pageSize"
          @pagination="onChangePages"
        />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisble"
      width="30%"
      @close="handleDialogClose"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="桥隧名称" prop="bridgesTunnelsName">
          <el-input v-model="form.bridgesTunnelsName" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="区站" prop="stationId">
          <el-select v-model="form.stationId" placeholder="请选择区站">
            <el-option
              v-for="item in stationList"
              :key="item.stationId"
              :label="item.stationName"
              :value="item.stationId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm('form')"
        >{{dialogTitle === '新增'? '立即添加': '立即修改'}}</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {
  getbridgesTunnelsList,
  bridgesTunnelsAdd,
  bridgesTunnelsById,
  updeteBridgesTunnels,
  deleteBridgesTunnels
} from "@/api/data-service/tunnel.js";
import { getStationAll } from "@/api/data-service/station.js";
export default {
  components: {
    Pagination
  },
  data() {
    return {
      form: {
        bridgesTunnelsName: "", //桥隧名称
        stationId: "", //负责人
        // delFlag: "0" // ?
      },
      rules: {
        bridgesTunnelsName: [
          { required: true, message: "请填写桥隧名称", trigger: "blur" }
        ],
        stationId: [
          { required: true, message: "请选择区站", trigger: "change" }
        ]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      dialogFormVisble: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "桥隧名称", code: "bridgesTunnelsName", width: "" },
        { name: "区站", code: "stationName", width: "" }
      ],

      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        bridgesTunnelsName: "",
        orderBy: ""
      },
      stationList: []
    };
  },
  mounted() {
    this.onGetDataList();
    this.queryStationList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    queryStationList() {
      getStationAll({
        circuitName: "", //线路名称
        // delFlag: "0", // ?
        orderByColumn: "",
        isAsc: "",
        orderBy: "",
        ...this.pageParams
      }).then(res => {
        this.stationList = res?.data || [];
      });
    },
    addData() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            bridgesTunnelsAdd(this.form).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteBridgesTunnels({
              ...this.form,
              bridgesTunnelsId: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.dialogFormVisble = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteBridgesTunnels({ ids: [row.bridgesTunnelsId] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.dialogFormVisble = true;
      this.updateId = row.bridgesTunnelsId;
      bridgesTunnelsById({ id: row.bridgesTunnelsId }).then(res => {
        const { bridgesTunnelsName, stationId } = res.data;
        this.form.bridgesTunnelsName = bridgesTunnelsName;
        this.form.stationId = stationId;
      });
    },
    // 查
    onGetDataList() {
      getbridgesTunnelsList({
        ...this.queryParams,
        ...this.pageParams
      }).then(res => {
        const { records, total } = res.data;
        this.tableData = records;
        this.pageParams.total = total;
      });
    },

    handlebridgesTunnelsAdd() {
      this.dialogTitle = "新增";
      this.dialogFormVisble = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
            this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.bridgesTunnelsName = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}
.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}
.margin-top {
  margin-top: -15px;
}
.custom-tree-node {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  .tree-node-label {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
